export enum CompanyModals {
  NO_CBE,
  NEEDS_ENRICHEMENT,
  WRONG_CBE,
}
